"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const framer_motion_1 = require("framer-motion");
const classnames_1 = __importDefault(require("classnames"));
const router_1 = require("next/router");
const TabContext_1 = __importDefault(require("../../contexts/TabContext"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const helpers_1 = require("../../lib/helpers");
const useAddToForwardRef_1 = require("../../hocs/useAddToForwardRef");
const TabButton = (props) => {
    const { children, name, href, onClick } = props;
    const { onTabChange, currentTab, hasIndicator, } = react_1.useContext(TabContext_1.default);
    let isActive = currentTab === name;
    const router = router_1.useRouter();
    if (href && helpers_1.withoutQueryParams(router.asPath) === href) {
        isActive = true;
    }
    const onClickHandle = react_1.useCallback((e) => {
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(name);
        // @ts-ignore
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [name, onClick, onTabChange]);
    const buttonRef = react_1.useRef();
    const forwardedRef = useAddToForwardRef_1.useAddToForwardRef(props, [buttonRef]);
    const primitiveProps = helpers_1.usePrimitiveProps(props, { className: classnames_1.default('j-button', { active: isActive }) });
    return (react_1.default.createElement("button", Object.assign({ type: "button" }, primitiveProps, { onClick: onClickHandle, ref: forwardedRef }),
        react_1.default.createElement("span", { className: "j-tab-button-content" }, children),
        hasIndicator && isActive && (
        // Since there is horizontal scrolling for mobile via, dont add any spring anim otherwise it will popout a horizontal scrollbar
        // due to spring going over its bounds.
        react_1.default.createElement(framer_motion_1.motion.div, { className: "j-tab-button-indicator", layoutId: "tab-indicator" }))));
};
exports.default = withJourney_1.default('j-tab-button', TabButton);
